module.exports = __webpack_public_path__ + "static/media/ProudOf_Me_Discover.fa06ffcf.PNG";